import styled from "styled-components";

import { IHeaderComponent } from "@components";
import { breakpoint } from "src//Utilities/theme";
import { Z_INDEX } from "@constants";

export const StyledHeader = styled.div<IHeaderComponent & { $hasTopBanner?: boolean }>`
    position: ${({ $headerFix }) => ($headerFix ? "fixed" : "sticky")};
    top: ${({ $hasTopBanner }) => ($hasTopBanner ? "28px" : "0")};
    z-index: ${Z_INDEX.HEADER};
    width: 100%;
    transition: 300ms;
    height: 90px;

    ${breakpoint.breakLarge`
        padding: 0;
    `}

    .backgroundHeader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: ${({ $headerFix, $isScrollUp }) => ($isScrollUp || !$headerFix ? "100%" : "0")};
        background-color: ${({ $headerFix, $isScrollUp }) =>
            $isScrollUp || !$headerFix ? "#fff" : "transparent"};
        border-bottom: 1px solid
            ${(p) => (p.$isScrollUp || !p.$headerFix ? p.theme.colors.gray_5 : "transparent")};
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        ${breakpoint.breakMobileMedium`
            width: ${(props) => props.theme.widths.wide_700};
            margin: 0 auto; 
        `}

        ${breakpoint.breakTablet`
            width: ${(props) => props.theme.widths.wide_750};
        `}

        ${breakpoint.breakIpadPro`
            width: ${(props) => props.theme.widths.wide_900};
            margin: 0 auto; 
        `}

        ${breakpoint.breakLarge`
            width: ${(props) => props.theme.widths.wide_1150};
        `}
    }

    .logo {
        height: 35px;
        position: relative;
        /* Both logo images are absolutely positioned, which leaves the anchor with
           no intrinsic width — so the flex row reserved no space for it and the
           artwork simply overlapped whatever sat to its right. Sizing the anchor
           instead, and letting the image fill it, makes one width rule govern both
           the layout and how large the logo draws. */
        width: 250px;
        /* Yields before the icons do: the row can steal width back from the logo,
           never from the burger or account button. */
        flex: 0 1 auto;
        min-width: 0;

        ${breakpoint.breakOnlyMobile`
            width: 150px;
            height: 28px;
        `}

        .logoItem {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 100%;

            &.logoWhite {
                opacity: ${({ $headerFix, $isScrollUp }) =>
                    $isScrollUp || !$headerFix ? "0" : "1"};
            }

            &.logoColor {
                opacity: ${({ $headerFix, $isScrollUp }) =>
                    $isScrollUp || !$headerFix ? "1" : "0"};
            }
        }
    }

    .cart {
        display: flex;
        position: relative;
        align-items: center;
        margin-left: auto;
        /* Never compressed or pushed off the row — the account button and cart are
           the only way out of the header on a phone. */
        flex-shrink: 0;
        ${breakpoint.breakIpadPro`
            width: auto;
        `}
        ${breakpoint.breakLarge`
            width: auto;
        `}

        .cartIconWrapper {
            position: relative;
            width: 26px;
            height: 26px;
            cursor: pointer;

            ${breakpoint.breakOnlyMobile`
                margin-left: 18px;
            `}

            ${breakpoint.breakTablet`
                display: flex;
                margin-left: 30px;
            `}

            .number {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 14px;
                height: 14px;
                font-size: 10px;
                border-radius: 50%;
                color: ${(props) => props.theme.colors.button_text};
                top: 0;
                left: 100%;
                transform: translateX(-50%);
                background-color: ${(props) => props.theme.colors.main};
                z-index: ${Z_INDEX.CONTENT_MID};
            }

            svg {
                path {
                    stroke: ${({ $headerFix, $isScrollUp, theme }) =>
                        $isScrollUp || !$headerFix ? theme.colors.black : "#fff"};
                }
            }
        }

        .userIconWrapper {
            display: none;
            min-width: 35px;
            height: 35px;
            position: relative;
            justify-content: center;
            align-items: center;
            border-radius: 50px;
            background-color: ${(p) => (p.$isShowMenu ? p.theme.colors.gray_6 : "transparent")};
            transition: 300ms;

            ${breakpoint.breakTablet`
                display: flex;
                margin-left: 30px;
            `}

            svg {
                cursor: pointer;

                path {
                    stroke: ${({ $headerFix, $isScrollUp, theme, $isShowMenu }) =>
                        $isScrollUp || !$headerFix || $isShowMenu ? theme.colors.black : "#fff"};
                }
            }

            /* Alert badge for an account still holding the password generated at
               sign-up. Shaped like the cart's count bubble above so the two read as
               the same kind of mark, with a white ring so it stays legible over the
               hero image as well as white. */
            .passwordAlert {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 15px;
                height: 15px;
                top: 0;
                right: 0;
                border-radius: 50%;
                background-color: ${(p) => p.theme.colors.red};
                border: 1.5px solid #fff;
                color: #fff;
                font-size: 10px;
                font-weight: 700;
                line-height: 1;
                /* The badge is decoration over a button that already handles the
                   click; swallowing the tap here would open nothing. */
                pointer-events: none;
            }
        }
    }
`;

export const StyledHeaderTitle = styled.h6<{ $hasTopBanner?: boolean }>`
    font-size: 18px;
    font-weight: 700;
    line-height: 23px;
    padding-top: 44px;
    padding-bottom: 28px;
    text-align: center;
    color: #fff;
    background-color: ${(props) => props.theme.colors.main};
    position: sticky;
    top: ${({ $hasTopBanner }) => ($hasTopBanner ? "28px" : "0")};
    top: 0;
    z-index: ${Z_INDEX.CONTENT_LOW};
`;
